// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".documentation-editor .tox.tox-tinymce{min-height:360px}", "",{"version":3,"sources":["webpack://./resources/js/views/pages/workspace/documentation/new.vue"],"names":[],"mappings":"AACA,uCACI,gBAAJ","sourcesContent":["\n.documentation-editor .tox.tox-tinymce {\n    min-height: 360px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
